(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/**
 * @typedef StationChangeEventData
 * @property {Station} station
 */ /**
 * Base abstract CustomEvent class for PlayOST
 */ class $323a7ebe6d2042d1$var$AbstractEvent {
    /** @var {string|null} eventName The custom event's name */ eventName = null;
    /**
     * Self factory
     * @return {AbstractEvent}
     */ static getInstance() {
        return new this();
    }
    /**
     * self.eventName getter
     * @return string
     */ getEventName() {
        return this.eventName;
    }
    /** Generate event data for CustomEvent */ toJson() {
        return {};
    }
    /**
     * Bind the given function to the current event
     * @param {Function} fn
     */ bind(fn) {
        if (this.eventName === null) throw new Error(`The event ${this.constructor.name}'s name must be set.`);
        document.addEventListener(this.eventName, (e)=>{
            fn(e.detail);
        });
    }
    /** Dispatch the event */ dispatch() {
        if (this.eventName === null) throw new Error(`The event ${this.constructor.name}'s name must be set.`);
        //console.debug(`Dispatching: ${this.getEventName()}`);
        document.dispatchEvent(new CustomEvent(this.eventName, {
            detail: this.toJson()
        }));
    }
}
var $323a7ebe6d2042d1$export$2e2bcd8739ae039 = $323a7ebe6d2042d1$var$AbstractEvent;


class $5a530bd591a84222$var$StationChangeEvent extends (0, $323a7ebe6d2042d1$export$2e2bcd8739ae039) {
    /** @inheritDoc */ eventName = 'playost.station.change';
    /** @var {Station} station */ station;
    /**
     * @inheritDoc
     * @param {Station} station
     */ constructor(station){
        super();
        this.station = station;
    }
    /**
     * Extract the station from a StationChangeEvent
     * @param {StationChangeEventData} evData
     * @return {Station|null}
     */ static getStation(evData) {
        return evData.station || null;
    }
    /**
     * @inheritDoc
     * @return {StationChangeEventData}
     */ toJson() {
        return {
            station: this.station
        };
    }
}
var $5a530bd591a84222$export$2e2bcd8739ae039 = $5a530bd591a84222$var$StationChangeEvent;


/**
 * @typedef StationsFetchedEventData
 * @property {Station} defaultStation
 * @property {Object<string, Station>} stations
 */ 
class $b59c416e021af273$var$StationsFetchedEvent extends (0, $323a7ebe6d2042d1$export$2e2bcd8739ae039) {
    /** @inheritDoc */ eventName = 'playost.station.initialized';
    /** @var {Object<string, Station>} stations */ stations;
    /** @var {Station} stations */ defaultStation;
    /**
     * @inheritDoc
     * @param {Object<string, Station>} stations
     * @param {Station} defaultStation
     */ constructor(stations, defaultStation){
        super();
        this.stations = stations;
        this.defaultStation = defaultStation;
    }
    /**
     * Extract the default station from the StationsFetchedEvent
     * @param {StationsFetchedEventData} evData
     * @return {Station|null}
     */ static getDefaultStation(evData) {
        return evData.defaultStation || null;
    }
    /**
     * @inheritDoc
     * @param {StationsFetchedEventData} evData
     * @return {Station[]|null}
     */ static getStations(evData) {
        return evData.stations || null;
    }
    /**
     * Generate event data for CustomEvent
     * @return {StationsFetchedEventData}
     */ toJson() {
        return {
            defaultStation: this.defaultStation,
            stations: this.stations
        };
    }
}
var $b59c416e021af273$export$2e2bcd8739ae039 = $b59c416e021af273$var$StationsFetchedEvent;


class $f654c2c4c7a6b3f4$var$AbstractBasicController {
    /** @var {Object} options The controller's options */ options = {};
    /** @var {Object.<string, HTMLElement>} dom The HTMLElement instance of each sub elements */ dom = {};
    /**
     * Self constructor
     * @param {Object} config
     */ constructor(config = {}){
        this.options = {
            ...this.options,
            ...config
        };
        if (this.options.selectors) for(let el in this.options.selectors)this.dom[el] = document.querySelector(this.options.selectors[el]);
    }
}
var $f654c2c4c7a6b3f4$export$2e2bcd8739ae039 = $f654c2c4c7a6b3f4$var$AbstractBasicController;


const $61621335a50cffc3$var$ObjectTool = {
    /**
     * Create a deep merged object with two given object
     * @param {Object} source
     * @param {Object} target
     */ deepMerge: (source, target)=>{
        const result = {
            ...source
        };
        for(let key in target)if (target.hasOwnProperty(key)) {
            if (target[key] instanceof Object && source[key] instanceof Object) result[key] = $61621335a50cffc3$var$ObjectTool.deepMerge(source[key], target[key]);
            else result[key] = target[key];
        }
        return result;
    }
};
var $61621335a50cffc3$export$2e2bcd8739ae039 = $61621335a50cffc3$var$ObjectTool;


class $fcfb5ebe1c2d73a6$var$RadioStationListController extends (0, $f654c2c4c7a6b3f4$export$2e2bcd8739ae039) {
    /** @var {Object<string, Station>} stations The list of the radio stations */ stations = {};
    /** @var {Object<string, HTMLElement>} domStations The HTMLElement instance of each station button */ domStations = {};
    /** @var {Station} selectedStation The current playing station */ selectedStation;
    /**
	 * Self constructor
	 * @param {Object} config
	 * @param {Station[]} stations
	 */ constructor(config, stations){
        config = (0, $61621335a50cffc3$export$2e2bcd8739ae039).deepMerge({
            selectors: {
                stationsWrapper: '.player__stations',
                template: '.station__button_template'
            }
        }, config);
        super(config);
        const _self = this;
        stations.forEach((s)=>_self.stations[s.shortcode] = s);
        this.generateDomTemplate();
    }
    /** Generate a DOM version of the template */ generateDomTemplate() {
        const parsedDOM = new DOMParser().parseFromString(this.dom.template.innerHTML.trim(), 'text/html');
        this.domTemplate = parsedDOM.body.firstChild.cloneNode(true);
    }
    /**
	 * Generate the buttons list for each station
	 * @return {RadioStationListController}
	 */ generate() {
        const _self = this;
        this.dom.stationsWrapper.innerHTML = '';
        for(let k in this.stations){
            let station = this.stations[k];
            this.domStations[station.shortcode] = this.domTemplate.cloneNode(true);
            this.domStations[station.shortcode].dataset.station = station.shortcode;
            if (this.domStations[station.shortcode].matches('[data-field="name"]')) this.domStations[station.shortcode].textContent = station.name;
            else this.domStations[station.shortcode].querySelector('[data-field="name"]');
            this.dom.stationsWrapper.append(this.domStations[station.shortcode]);
            this.domStations[station.shortcode].addEventListener('click', (e)=>_self.onStationChange(e), false);
        }
        // If there is no default station, triggering the first one
        let aDomKeys = Object.keys(this.domStations);
        if (aDomKeys.length > 0) {
            this.selectedStation = this.stations[aDomKeys[0]];
            this.domStations[aDomKeys[0]].classList.add('active');
        }
        // Adding station shortcode to body as className
        document.body.classList.add(`station-${this.selectedStation.shortcode}`);
        // Dispatching the event
        new (0, $b59c416e021af273$export$2e2bcd8739ae039)(_self.stations, _self.selectedStation).dispatch();
        return this;
    }
    /**
	 * Station change callback
	 * @param {Event} e
	 */ onStationChange(e) {
        const _self = this;
        // First, removing the previous station className from the body
        document.body.classList.remove(`station-${this.selectedStation.shortcode}`);
        this.selectedStation = this.stations[e.currentTarget.dataset.station];
        e.currentTarget.parentElement.querySelectorAll('.controls__stream').forEach((el)=>{
            el.classList.remove('active');
        });
        e.currentTarget.classList.add('active');
        // Adding new station className to the body
        document.body.classList.add(`station-${this.selectedStation.shortcode}`);
        new (0, $5a530bd591a84222$export$2e2bcd8739ae039)(_self.selectedStation).dispatch();
    }
}
var $fcfb5ebe1c2d73a6$export$2e2bcd8739ae039 = $fcfb5ebe1c2d73a6$var$RadioStationListController;



const $4a05199e3e345b29$var$ArtworkVerifier = {
    /**
     * Verify if the given URL properly exists and is not redirected or whatsoever
     * @param {string} url
     * @return {Promise<unknown>}
     */ verify: (url)=>{
        return new Promise((resolve, reject)=>{
            fetch(url).then((resp)=>{
                resp.status === 200 ? resolve() : reject();
            }).catch(()=>reject());
        });
    }
};
var $4a05199e3e345b29$export$2e2bcd8739ae039 = $4a05199e3e345b29$var$ArtworkVerifier;



var $e76ad0e8457140cb$var$t = function(t, r) {
    return t < r ? -1 : t > r ? 1 : 0;
}, $e76ad0e8457140cb$var$r = function(t) {
    return t.reduce(function(t, r) {
        return t + r;
    }, 0);
}, $e76ad0e8457140cb$var$n = /*#__PURE__*/ function() {
    function t(t) {
        this.colors = t;
    }
    var r = t.prototype;
    return r.palette = function() {
        return this.colors;
    }, r.map = function(t) {
        return t;
    }, t;
}(), $e76ad0e8457140cb$var$o = function() {
    function o(t, r, n) {
        return (t << 10) + (r << 5) + n;
    }
    function e(t) {
        var r = [], n = !1;
        function o() {
            r.sort(t), n = !0;
        }
        return {
            push: function(t) {
                r.push(t), n = !1;
            },
            peek: function(t) {
                return n || o(), void 0 === t && (t = r.length - 1), r[t];
            },
            pop: function() {
                return n || o(), r.pop();
            },
            size: function() {
                return r.length;
            },
            map: function(t) {
                return r.map(t);
            },
            debug: function() {
                return n || o(), r;
            }
        };
    }
    function i1(t, r, n, o, e, i1, u) {
        var a = this;
        a.r1 = t, a.r2 = r, a.g1 = n, a.g2 = o, a.b1 = e, a.b2 = i1, a.histo = u;
    }
    function u() {
        this.vboxes = new e(function(r, n) {
            return $e76ad0e8457140cb$var$t(r.vbox.count() * r.vbox.volume(), n.vbox.count() * n.vbox.volume());
        });
    }
    function a(t, r) {
        if (r.count()) {
            var n = r.r2 - r.r1 + 1, e = r.g2 - r.g1 + 1, i1 = Math.max.apply(null, [
                n,
                e,
                r.b2 - r.b1 + 1
            ]);
            if (1 == r.count()) return [
                r.copy()
            ];
            var u, a, c, f, s = 0, h = [], v = [];
            if (i1 == n) for(u = r.r1; u <= r.r2; u++){
                for(f = 0, a = r.g1; a <= r.g2; a++)for(c = r.b1; c <= r.b2; c++)f += t[o(u, a, c)] || 0;
                h[u] = s += f;
            }
            else if (i1 == e) for(u = r.g1; u <= r.g2; u++){
                for(f = 0, a = r.r1; a <= r.r2; a++)for(c = r.b1; c <= r.b2; c++)f += t[o(a, u, c)] || 0;
                h[u] = s += f;
            }
            else for(u = r.b1; u <= r.b2; u++){
                for(f = 0, a = r.r1; a <= r.r2; a++)for(c = r.g1; c <= r.g2; c++)f += t[o(a, c, u)] || 0;
                h[u] = s += f;
            }
            return h.forEach(function(t, r) {
                v[r] = s - t;
            }), function(t) {
                var n, o, e, i1, a, c = t + "1", f = t + "2", l = 0;
                for(u = r[c]; u <= r[f]; u++)if (h[u] > s / 2) {
                    for(e = r.copy(), i1 = r.copy(), a = (n = u - r[c]) <= (o = r[f] - u) ? Math.min(r[f] - 1, ~~(u + o / 2)) : Math.max(r[c], ~~(u - 1 - n / 2)); !h[a];)a++;
                    for(l = v[a]; !l && h[a - 1];)l = v[--a];
                    return e[f] = a, i1[c] = e[f] + 1, [
                        e,
                        i1
                    ];
                }
            }(i1 == n ? "r" : i1 == e ? "g" : "b");
        }
    }
    return i1.prototype = {
        volume: function(t) {
            var r = this;
            return r._volume && !t || (r._volume = (r.r2 - r.r1 + 1) * (r.g2 - r.g1 + 1) * (r.b2 - r.b1 + 1)), r._volume;
        },
        count: function(t) {
            var r = this, n = r.histo;
            if (!r._count_set || t) {
                var e, i1, u, a = 0;
                for(e = r.r1; e <= r.r2; e++)for(i1 = r.g1; i1 <= r.g2; i1++)for(u = r.b1; u <= r.b2; u++)a += n[o(e, i1, u)] || 0;
                r._count = a, r._count_set = !0;
            }
            return r._count;
        },
        copy: function() {
            var t = this;
            return new i1(t.r1, t.r2, t.g1, t.g2, t.b1, t.b2, t.histo);
        },
        avg: function(t) {
            var r = this, n = r.histo;
            if (!r._avg || t) {
                var e, i1, u, a, c = 0, f = 0, s = 0, h = 0;
                if (r.r1 === r.r2 && r.g1 === r.g2 && r.b1 === r.b2) r._avg = [
                    r.r1 << 3,
                    r.g1 << 3,
                    r.b1 << 3
                ];
                else {
                    for(i1 = r.r1; i1 <= r.r2; i1++)for(u = r.g1; u <= r.g2; u++)for(a = r.b1; a <= r.b2; a++)c += e = n[o(i1, u, a)] || 0, f += e * (i1 + .5) * 8, s += e * (u + .5) * 8, h += e * (a + .5) * 8;
                    r._avg = c ? [
                        ~~(f / c),
                        ~~(s / c),
                        ~~(h / c)
                    ] : [
                        ~~(8 * (r.r1 + r.r2 + 1) / 2),
                        ~~(8 * (r.g1 + r.g2 + 1) / 2),
                        ~~(8 * (r.b1 + r.b2 + 1) / 2)
                    ];
                }
            }
            return r._avg;
        },
        contains: function(t) {
            var r = this, n = t[0] >> 3;
            return gval = t[1] >> 3, bval = t[2] >> 3, n >= r.r1 && n <= r.r2 && gval >= r.g1 && gval <= r.g2 && bval >= r.b1 && bval <= r.b2;
        }
    }, u.prototype = {
        push: function(t) {
            this.vboxes.push({
                vbox: t,
                color: t.avg()
            });
        },
        palette: function() {
            return this.vboxes.map(function(t) {
                return t.color;
            });
        },
        size: function() {
            return this.vboxes.size();
        },
        map: function(t) {
            for(var r = this.vboxes, n = 0; n < r.size(); n++)if (r.peek(n).vbox.contains(t)) return r.peek(n).color;
            return this.nearest(t);
        },
        nearest: function(t) {
            for(var r, n, o, e = this.vboxes, i1 = 0; i1 < e.size(); i1++)((n = Math.sqrt(Math.pow(t[0] - e.peek(i1).color[0], 2) + Math.pow(t[1] - e.peek(i1).color[1], 2) + Math.pow(t[2] - e.peek(i1).color[2], 2))) < r || void 0 === r) && (r = n, o = e.peek(i1).color);
            return o;
        },
        forcebw: function() {
            var n = this.vboxes;
            n.sort(function(n, o) {
                return $e76ad0e8457140cb$var$t($e76ad0e8457140cb$var$r(n.color), $e76ad0e8457140cb$var$r(o.color));
            });
            var o = n[0].color;
            o[0] < 5 && o[1] < 5 && o[2] < 5 && (n[0].color = [
                0,
                0,
                0
            ]);
            var e = n.length - 1, i1 = n[e].color;
            i1[0] > 251 && i1[1] > 251 && i1[2] > 251 && (n[e].color = [
                255,
                255,
                255
            ]);
        }
    }, {
        quantize: function(r, c) {
            if (!Number.isInteger(c) || c < 1 || c > 256) throw new Error("Invalid maximum color count. It must be an integer between 1 and 256.");
            if (!r.length || c < 2 || c > 256) return !1;
            if (!r.length || c < 2 || c > 256) return !1;
            for(var f = [], s = new Set, h = 0; h < r.length; h++){
                var v = r[h], l = v.join(",");
                s.has(l) || (s.add(l), f.push(v));
            }
            if (f.length <= c) return new $e76ad0e8457140cb$var$n(f);
            var g = function(t) {
                var r, n = new Array(32768);
                return t.forEach(function(t) {
                    r = o(t[0] >> 3, t[1] >> 3, t[2] >> 3), n[r] = (n[r] || 0) + 1;
                }), n;
            }(r);
            g.forEach(function() {});
            var p = function(t, r) {
                var n, o, e, u = 1e6, a = 0, c = 1e6, f = 0, s = 1e6, h = 0;
                return t.forEach(function(t) {
                    (n = t[0] >> 3) < u ? u = n : n > a && (a = n), (o = t[1] >> 3) < c ? c = o : o > f && (f = o), (e = t[2] >> 3) < s ? s = e : e > h && (h = e);
                }), new i1(u, a, c, f, s, h, r);
            }(r, g), b = new e(function(r, n) {
                return $e76ad0e8457140cb$var$t(r.count(), n.count());
            });
            function m(t, r) {
                for(var n, o = t.size(), e = 0; e < 1e3;){
                    if (o >= r) return;
                    if (e++ > 1e3) return;
                    if ((n = t.pop()).count()) {
                        var i1 = a(g, n), u = i1[0], c = i1[1];
                        if (!u) return;
                        t.push(u), c && (t.push(c), o++);
                    } else t.push(n), e++;
                }
            }
            b.push(p), m(b, .75 * c);
            for(var d = new e(function(r, n) {
                return $e76ad0e8457140cb$var$t(r.count() * r.volume(), n.count() * n.volume());
            }); b.size();)d.push(b.pop());
            m(d, c);
            for(var w = new u; d.size();)w.push(d.pop());
            return w;
        }
    };
}().quantize, $e76ad0e8457140cb$var$e = function(t) {
    this.canvas = document.createElement("canvas"), this.context = this.canvas.getContext("2d"), this.width = this.canvas.width = t.naturalWidth, this.height = this.canvas.height = t.naturalHeight, this.context.drawImage(t, 0, 0, this.width, this.height);
};
$e76ad0e8457140cb$var$e.prototype.getImageData = function() {
    return this.context.getImageData(0, 0, this.width, this.height);
};
var $e76ad0e8457140cb$export$2e2bcd8739ae039 = function() {};
$e76ad0e8457140cb$export$2e2bcd8739ae039.prototype.getColor = function(t, r) {
    return void 0 === r && (r = 10), this.getPalette(t, 5, r)[0];
}, $e76ad0e8457140cb$export$2e2bcd8739ae039.prototype.getPalette = function(t, r, n) {
    var i1 = function(t) {
        var r = t.colorCount, n = t.quality;
        if (void 0 !== r && Number.isInteger(r)) {
            if (1 === r) throw new Error("colorCount should be between 2 and 20. To get one color, call getColor() instead of getPalette()");
            r = Math.max(r, 2), r = Math.min(r, 20);
        } else r = 10;
        return (void 0 === n || !Number.isInteger(n) || n < 1) && (n = 10), {
            colorCount: r,
            quality: n
        };
    }({
        colorCount: r,
        quality: n
    }), u = new $e76ad0e8457140cb$var$e(t), a = function(t, r, n) {
        for(var o, e, i1, u, a, c = t, f = [], s = 0; s < r; s += n)e = c[0 + (o = 4 * s)], i1 = c[o + 1], u = c[o + 2], (void 0 === (a = c[o + 3]) || a >= 125) && (e > 250 && i1 > 250 && u > 250 || f.push([
            e,
            i1,
            u
        ]));
        return f;
    }(u.getImageData().data, u.width * u.height, i1.quality), c = $e76ad0e8457140cb$var$o(a, i1.colorCount);
    return c ? c.palette() : null;
}, $e76ad0e8457140cb$export$2e2bcd8739ae039.prototype.getColorFromUrl = function(t, r, n) {
    var o = this, e = document.createElement("img");
    e.addEventListener("load", function() {
        var i1 = o.getPalette(e, 5, n);
        r(i1[0], t);
    }), e.src = t;
}, $e76ad0e8457140cb$export$2e2bcd8739ae039.prototype.getImageData = function(t, r) {
    var n = new XMLHttpRequest;
    n.open("GET", t, !0), n.responseType = "arraybuffer", n.onload = function() {
        if (200 == this.status) {
            var t = new Uint8Array(this.response);
            i = t.length;
            for(var n = new Array(i), o = 0; o < t.length; o++)n[o] = String.fromCharCode(t[o]);
            var e = n.join(""), u = window.btoa(e);
            r("data:image/png;base64," + u);
        }
    }, n.send();
}, $e76ad0e8457140cb$export$2e2bcd8739ae039.prototype.getColorAsync = function(t, r, n) {
    var o = this;
    this.getImageData(t, function(t) {
        var e = document.createElement("img");
        e.addEventListener("load", function() {
            var t = o.getPalette(e, 5, n);
            r(t[0], this);
        }), e.src = t;
    });
};


var $fa90ed4ba7c7f833$exports = {};
// This file is autogenerated. It's used to publish CJS to npm.
(function(global, factory) {
    $fa90ed4ba7c7f833$exports = factory();
})($fa90ed4ba7c7f833$exports, function() {
    'use strict';
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    // https://github.com/bgrins/TinyColor
    // Brian Grinstead, MIT License
    var trimLeft = /^\s+/;
    var trimRight = /\s+$/;
    function tinycolor(color, opts) {
        color = color ? color : "";
        opts = opts || {};
        // If input is already a tinycolor, return itself
        if (color instanceof tinycolor) return color;
        // If we are called as a function, call using new instead
        if (!(this instanceof tinycolor)) return new tinycolor(color, opts);
        var rgb = inputToRGB(color);
        this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
        this._gradientType = opts.gradientType;
        // Don't let the range of [0,255] come back in [0,1].
        // Potentially lose a little bit of precision here, but will fix issues where
        // .5 gets interpreted as half of the total, instead of half of 1
        // If it was supposed to be 128, this was already taken care of by `inputToRgb`
        if (this._r < 1) this._r = Math.round(this._r);
        if (this._g < 1) this._g = Math.round(this._g);
        if (this._b < 1) this._b = Math.round(this._b);
        this._ok = rgb.ok;
    }
    tinycolor.prototype = {
        isDark: function isDark() {
            return this.getBrightness() < 128;
        },
        isLight: function isLight() {
            return !this.isDark();
        },
        isValid: function isValid() {
            return this._ok;
        },
        getOriginalInput: function getOriginalInput() {
            return this._originalInput;
        },
        getFormat: function getFormat() {
            return this._format;
        },
        getAlpha: function getAlpha() {
            return this._a;
        },
        getBrightness: function getBrightness() {
            //http://www.w3.org/TR/AERT#color-contrast
            var rgb = this.toRgb();
            return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
        },
        getLuminance: function getLuminance() {
            //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
            var rgb = this.toRgb();
            var RsRGB, GsRGB, BsRGB, R, G, B;
            RsRGB = rgb.r / 255;
            GsRGB = rgb.g / 255;
            BsRGB = rgb.b / 255;
            if (RsRGB <= 0.03928) R = RsRGB / 12.92;
            else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
            if (GsRGB <= 0.03928) G = GsRGB / 12.92;
            else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
            if (BsRGB <= 0.03928) B = BsRGB / 12.92;
            else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
            return 0.2126 * R + 0.7152 * G + 0.0722 * B;
        },
        setAlpha: function setAlpha(value) {
            this._a = boundAlpha(value);
            this._roundA = Math.round(100 * this._a) / 100;
            return this;
        },
        toHsv: function toHsv() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            return {
                h: hsv.h * 360,
                s: hsv.s,
                v: hsv.v,
                a: this._a
            };
        },
        toHsvString: function toHsvString() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            var h = Math.round(hsv.h * 360), s = Math.round(hsv.s * 100), v = Math.round(hsv.v * 100);
            return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
        },
        toHsl: function toHsl() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            return {
                h: hsl.h * 360,
                s: hsl.s,
                l: hsl.l,
                a: this._a
            };
        },
        toHslString: function toHslString() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            var h = Math.round(hsl.h * 360), s = Math.round(hsl.s * 100), l = Math.round(hsl.l * 100);
            return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
        },
        toHex: function toHex(allow3Char) {
            return rgbToHex(this._r, this._g, this._b, allow3Char);
        },
        toHexString: function toHexString(allow3Char) {
            return "#" + this.toHex(allow3Char);
        },
        toHex8: function toHex8(allow4Char) {
            return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
        },
        toHex8String: function toHex8String(allow4Char) {
            return "#" + this.toHex8(allow4Char);
        },
        toRgb: function toRgb() {
            return {
                r: Math.round(this._r),
                g: Math.round(this._g),
                b: Math.round(this._b),
                a: this._a
            };
        },
        toRgbString: function toRgbString() {
            return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
        },
        toPercentageRgb: function toPercentageRgb() {
            return {
                r: Math.round(bound01(this._r, 255) * 100) + "%",
                g: Math.round(bound01(this._g, 255) * 100) + "%",
                b: Math.round(bound01(this._b, 255) * 100) + "%",
                a: this._a
            };
        },
        toPercentageRgbString: function toPercentageRgbString() {
            return this._a == 1 ? "rgb(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
        },
        toName: function toName() {
            if (this._a === 0) return "transparent";
            if (this._a < 1) return false;
            return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
        },
        toFilter: function toFilter(secondColor) {
            var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
            var secondHex8String = hex8String;
            var gradientType = this._gradientType ? "GradientType = 1, " : "";
            if (secondColor) {
                var s = tinycolor(secondColor);
                secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
            }
            return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
        },
        toString: function toString(format) {
            var formatSet = !!format;
            format = format || this._format;
            var formattedString = false;
            var hasAlpha = this._a < 1 && this._a >= 0;
            var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
            if (needsAlphaFormat) {
                // Special case for "transparent", all other non-alpha formats
                // will return rgba when there is transparency.
                if (format === "name" && this._a === 0) return this.toName();
                return this.toRgbString();
            }
            if (format === "rgb") formattedString = this.toRgbString();
            if (format === "prgb") formattedString = this.toPercentageRgbString();
            if (format === "hex" || format === "hex6") formattedString = this.toHexString();
            if (format === "hex3") formattedString = this.toHexString(true);
            if (format === "hex4") formattedString = this.toHex8String(true);
            if (format === "hex8") formattedString = this.toHex8String();
            if (format === "name") formattedString = this.toName();
            if (format === "hsl") formattedString = this.toHslString();
            if (format === "hsv") formattedString = this.toHsvString();
            return formattedString || this.toHexString();
        },
        clone: function clone() {
            return tinycolor(this.toString());
        },
        _applyModification: function _applyModification(fn, args) {
            var color = fn.apply(null, [
                this
            ].concat([].slice.call(args)));
            this._r = color._r;
            this._g = color._g;
            this._b = color._b;
            this.setAlpha(color._a);
            return this;
        },
        lighten: function lighten() {
            return this._applyModification(_lighten, arguments);
        },
        brighten: function brighten() {
            return this._applyModification(_brighten, arguments);
        },
        darken: function darken() {
            return this._applyModification(_darken, arguments);
        },
        desaturate: function desaturate() {
            return this._applyModification(_desaturate, arguments);
        },
        saturate: function saturate() {
            return this._applyModification(_saturate, arguments);
        },
        greyscale: function greyscale() {
            return this._applyModification(_greyscale, arguments);
        },
        spin: function spin() {
            return this._applyModification(_spin, arguments);
        },
        _applyCombination: function _applyCombination(fn, args) {
            return fn.apply(null, [
                this
            ].concat([].slice.call(args)));
        },
        analogous: function analogous() {
            return this._applyCombination(_analogous, arguments);
        },
        complement: function complement() {
            return this._applyCombination(_complement, arguments);
        },
        monochromatic: function monochromatic() {
            return this._applyCombination(_monochromatic, arguments);
        },
        splitcomplement: function splitcomplement() {
            return this._applyCombination(_splitcomplement, arguments);
        },
        // Disabled until https://github.com/bgrins/TinyColor/issues/254
        // polyad: function (number) {
        //   return this._applyCombination(polyad, [number]);
        // },
        triad: function triad() {
            return this._applyCombination(polyad, [
                3
            ]);
        },
        tetrad: function tetrad() {
            return this._applyCombination(polyad, [
                4
            ]);
        }
    };
    // If input is an object, force 1 into "1.0" to handle ratios properly
    // String input requires "1.0" as input, so 1 will be treated as 1
    tinycolor.fromRatio = function(color, opts) {
        if (_typeof(color) == "object") {
            var newColor = {};
            for(var i in color)if (color.hasOwnProperty(i)) {
                if (i === "a") newColor[i] = color[i];
                else newColor[i] = convertToPercentage(color[i]);
            }
            color = newColor;
        }
        return tinycolor(color, opts);
    };
    // Given a string or object, convert that input to RGB
    // Possible string inputs:
    //
    //     "red"
    //     "#f00" or "f00"
    //     "#ff0000" or "ff0000"
    //     "#ff000000" or "ff000000"
    //     "rgb 255 0 0" or "rgb (255, 0, 0)"
    //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
    //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
    //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
    //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
    //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
    //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
    //
    function inputToRGB(color) {
        var rgb = {
            r: 0,
            g: 0,
            b: 0
        };
        var a = 1;
        var s = null;
        var v = null;
        var l = null;
        var ok = false;
        var format = false;
        if (typeof color == "string") color = stringInputToObject(color);
        if (_typeof(color) == "object") {
            if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
                rgb = rgbToRgb(color.r, color.g, color.b);
                ok = true;
                format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
            } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
                s = convertToPercentage(color.s);
                v = convertToPercentage(color.v);
                rgb = hsvToRgb(color.h, s, v);
                ok = true;
                format = "hsv";
            } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
                s = convertToPercentage(color.s);
                l = convertToPercentage(color.l);
                rgb = hslToRgb(color.h, s, l);
                ok = true;
                format = "hsl";
            }
            if (color.hasOwnProperty("a")) a = color.a;
        }
        a = boundAlpha(a);
        return {
            ok: ok,
            format: color.format || format,
            r: Math.min(255, Math.max(rgb.r, 0)),
            g: Math.min(255, Math.max(rgb.g, 0)),
            b: Math.min(255, Math.max(rgb.b, 0)),
            a: a
        };
    }
    // Conversion Functions
    // --------------------
    // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
    // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
    // `rgbToRgb`
    // Handle bounds / percentage checking to conform to CSS color spec
    // <http://www.w3.org/TR/css3-color/>
    // *Assumes:* r, g, b in [0, 255] or [0, 1]
    // *Returns:* { r, g, b } in [0, 255]
    function rgbToRgb(r, g, b) {
        return {
            r: bound01(r, 255) * 255,
            g: bound01(g, 255) * 255,
            b: bound01(b, 255) * 255
        };
    }
    // `rgbToHsl`
    // Converts an RGB color value to HSL.
    // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
    // *Returns:* { h, s, l } in [0,1]
    function rgbToHsl(r, g, b) {
        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, l = (max + min) / 2;
        if (max == min) h = s = 0; // achromatic
        else {
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {
            h: h,
            s: s,
            l: l
        };
    }
    // `hslToRgb`
    // Converts an HSL color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hslToRgb(h, s, l) {
        var r, g, b;
        h = bound01(h, 360);
        s = bound01(s, 100);
        l = bound01(l, 100);
        function hue2rgb(p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 0.5) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        }
        if (s === 0) r = g = b = l; // achromatic
        else {
            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = hue2rgb(p, q, h + 1 / 3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1 / 3);
        }
        return {
            r: r * 255,
            g: g * 255,
            b: b * 255
        };
    }
    // `rgbToHsv`
    // Converts an RGB color value to HSV
    // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
    // *Returns:* { h, s, v } in [0,1]
    function rgbToHsv(r, g, b) {
        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, v = max;
        var d = max - min;
        s = max === 0 ? 0 : d / max;
        if (max == min) h = 0; // achromatic
        else {
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {
            h: h,
            s: s,
            v: v
        };
    }
    // `hsvToRgb`
    // Converts an HSV color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hsvToRgb(h, s, v) {
        h = bound01(h, 360) * 6;
        s = bound01(s, 100);
        v = bound01(v, 100);
        var i = Math.floor(h), f = h - i, p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s), mod = i % 6, r = [
            v,
            q,
            p,
            p,
            t,
            v
        ][mod], g = [
            t,
            v,
            v,
            q,
            p,
            p
        ][mod], b = [
            p,
            p,
            t,
            v,
            v,
            q
        ][mod];
        return {
            r: r * 255,
            g: g * 255,
            b: b * 255
        };
    }
    // `rgbToHex`
    // Converts an RGB color to hex
    // Assumes r, g, and b are contained in the set [0, 255]
    // Returns a 3 or 6 character hex
    function rgbToHex(r, g, b, allow3Char) {
        var hex = [
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16))
        ];
        // Return a 3 character hex if possible
        if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
        return hex.join("");
    }
    // `rgbaToHex`
    // Converts an RGBA color plus alpha transparency to hex
    // Assumes r, g, b are contained in the set [0, 255] and
    // a in [0, 1]. Returns a 4 or 8 character rgba hex
    function rgbaToHex(r, g, b, a, allow4Char) {
        var hex = [
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16)),
            pad2(convertDecimalToHex(a))
        ];
        // Return a 4 character hex if possible
        if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
        return hex.join("");
    }
    // `rgbaToArgbHex`
    // Converts an RGBA color to an ARGB Hex8 string
    // Rarely used, but required for "toFilter()"
    function rgbaToArgbHex(r, g, b, a) {
        var hex = [
            pad2(convertDecimalToHex(a)),
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16))
        ];
        return hex.join("");
    }
    // `equals`
    // Can be called with any tinycolor input
    tinycolor.equals = function(color1, color2) {
        if (!color1 || !color2) return false;
        return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
    };
    tinycolor.random = function() {
        return tinycolor.fromRatio({
            r: Math.random(),
            g: Math.random(),
            b: Math.random()
        });
    };
    // Modification Functions
    // ----------------------
    // Thanks to less.js for some of the basics here
    // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
    function _desaturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.s -= amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }
    function _saturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.s += amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }
    function _greyscale(color) {
        return tinycolor(color).desaturate(100);
    }
    function _lighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.l += amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }
    function _brighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var rgb = tinycolor(color).toRgb();
        rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
        rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
        rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
        return tinycolor(rgb);
    }
    function _darken(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.l -= amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }
    // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
    // Values outside of this range will be wrapped into this range.
    function _spin(color, amount) {
        var hsl = tinycolor(color).toHsl();
        var hue = (hsl.h + amount) % 360;
        hsl.h = hue < 0 ? 360 + hue : hue;
        return tinycolor(hsl);
    }
    // Combination Functions
    // ---------------------
    // Thanks to jQuery xColor for some of the ideas behind these
    // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
    function _complement(color) {
        var hsl = tinycolor(color).toHsl();
        hsl.h = (hsl.h + 180) % 360;
        return tinycolor(hsl);
    }
    function polyad(color, number) {
        if (isNaN(number) || number <= 0) throw new Error("Argument to polyad must be a positive number");
        var hsl = tinycolor(color).toHsl();
        var result = [
            tinycolor(color)
        ];
        var step = 360 / number;
        for(var i = 1; i < number; i++)result.push(tinycolor({
            h: (hsl.h + i * step) % 360,
            s: hsl.s,
            l: hsl.l
        }));
        return result;
    }
    function _splitcomplement(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({
                h: (h + 72) % 360,
                s: hsl.s,
                l: hsl.l
            }),
            tinycolor({
                h: (h + 216) % 360,
                s: hsl.s,
                l: hsl.l
            })
        ];
    }
    function _analogous(color, results, slices) {
        results = results || 6;
        slices = slices || 30;
        var hsl = tinycolor(color).toHsl();
        var part = 360 / slices;
        var ret = [
            tinycolor(color)
        ];
        for(hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;){
            hsl.h = (hsl.h + part) % 360;
            ret.push(tinycolor(hsl));
        }
        return ret;
    }
    function _monochromatic(color, results) {
        results = results || 6;
        var hsv = tinycolor(color).toHsv();
        var h = hsv.h, s = hsv.s, v = hsv.v;
        var ret = [];
        var modification = 1 / results;
        while(results--){
            ret.push(tinycolor({
                h: h,
                s: s,
                v: v
            }));
            v = (v + modification) % 1;
        }
        return ret;
    }
    // Utility Functions
    // ---------------------
    tinycolor.mix = function(color1, color2, amount) {
        amount = amount === 0 ? 0 : amount || 50;
        var rgb1 = tinycolor(color1).toRgb();
        var rgb2 = tinycolor(color2).toRgb();
        var p = amount / 100;
        var rgba = {
            r: (rgb2.r - rgb1.r) * p + rgb1.r,
            g: (rgb2.g - rgb1.g) * p + rgb1.g,
            b: (rgb2.b - rgb1.b) * p + rgb1.b,
            a: (rgb2.a - rgb1.a) * p + rgb1.a
        };
        return tinycolor(rgba);
    };
    // Readability Functions
    // ---------------------
    // <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
    // `contrast`
    // Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
    tinycolor.readability = function(color1, color2) {
        var c1 = tinycolor(color1);
        var c2 = tinycolor(color2);
        return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
    };
    // `isReadable`
    // Ensure that foreground and background color combinations meet WCAG2 guidelines.
    // The third argument is an optional Object.
    //      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
    //      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
    // If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
    // *Example*
    //    tinycolor.isReadable("#000", "#111") => false
    //    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
    tinycolor.isReadable = function(color1, color2, wcag2) {
        var readability = tinycolor.readability(color1, color2);
        var wcag2Parms, out;
        out = false;
        wcag2Parms = validateWCAG2Parms(wcag2);
        switch(wcag2Parms.level + wcag2Parms.size){
            case "AAsmall":
            case "AAAlarge":
                out = readability >= 4.5;
                break;
            case "AAlarge":
                out = readability >= 3;
                break;
            case "AAAsmall":
                out = readability >= 7;
                break;
        }
        return out;
    };
    // `mostReadable`
    // Given a base color and a list of possible foreground or background
    // colors for that base, returns the most readable color.
    // Optionally returns Black or White if the most readable color is unreadable.
    // *Example*
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
    tinycolor.mostReadable = function(baseColor, colorList, args) {
        var bestColor = null;
        var bestScore = 0;
        var readability;
        var includeFallbackColors, level, size;
        args = args || {};
        includeFallbackColors = args.includeFallbackColors;
        level = args.level;
        size = args.size;
        for(var i = 0; i < colorList.length; i++){
            readability = tinycolor.readability(baseColor, colorList[i]);
            if (readability > bestScore) {
                bestScore = readability;
                bestColor = tinycolor(colorList[i]);
            }
        }
        if (tinycolor.isReadable(baseColor, bestColor, {
            level: level,
            size: size
        }) || !includeFallbackColors) return bestColor;
        else {
            args.includeFallbackColors = false;
            return tinycolor.mostReadable(baseColor, [
                "#fff",
                "#000"
            ], args);
        }
    };
    // Big List of Colors
    // ------------------
    // <https://www.w3.org/TR/css-color-4/#named-colors>
    var names = tinycolor.names = {
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "0ff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000",
        blanchedalmond: "ffebcd",
        blue: "00f",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        burntsienna: "ea7e5d",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "0ff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgreen: "006400",
        darkgrey: "a9a9a9",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkslategrey: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dimgrey: "696969",
        dodgerblue: "1e90ff",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "f0f",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        green: "008000",
        greenyellow: "adff2f",
        grey: "808080",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgray: "d3d3d3",
        lightgreen: "90ee90",
        lightgrey: "d3d3d3",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslategray: "789",
        lightslategrey: "789",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "0f0",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "f0f",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370db",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "db7093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        rebeccapurple: "663399",
        red: "f00",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        slategrey: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        wheat: "f5deb3",
        white: "fff",
        whitesmoke: "f5f5f5",
        yellow: "ff0",
        yellowgreen: "9acd32"
    };
    // Make it easy to access colors via `hexNames[hex]`
    var hexNames = tinycolor.hexNames = flip(names);
    // Utilities
    // ---------
    // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
    function flip(o) {
        var flipped = {};
        for(var i in o)if (o.hasOwnProperty(i)) flipped[o[i]] = i;
        return flipped;
    }
    // Return a valid alpha value [0,1] with all invalid values being set to 1
    function boundAlpha(a) {
        a = parseFloat(a);
        if (isNaN(a) || a < 0 || a > 1) a = 1;
        return a;
    }
    // Take input from [0, n] and return it as [0, 1]
    function bound01(n, max) {
        if (isOnePointZero(n)) n = "100%";
        var processPercent = isPercentage(n);
        n = Math.min(max, Math.max(0, parseFloat(n)));
        // Automatically convert percentage into number
        if (processPercent) n = parseInt(n * max, 10) / 100;
        // Handle floating point rounding errors
        if (Math.abs(n - max) < 0.000001) return 1;
        // Convert into [0, 1] range if it isn't already
        return n % max / parseFloat(max);
    }
    // Force a number between 0 and 1
    function clamp01(val) {
        return Math.min(1, Math.max(0, val));
    }
    // Parse a base-16 hex value into a base-10 integer
    function parseIntFromHex(val) {
        return parseInt(val, 16);
    }
    // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
    // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
    function isOnePointZero(n) {
        return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
    }
    // Check to see if string passed in is a percentage
    function isPercentage(n) {
        return typeof n === "string" && n.indexOf("%") != -1;
    }
    // Force a hex value to have 2 characters
    function pad2(c) {
        return c.length == 1 ? "0" + c : "" + c;
    }
    // Replace a decimal with it's percentage value
    function convertToPercentage(n) {
        if (n <= 1) n = n * 100 + "%";
        return n;
    }
    // Converts a decimal to a hex value
    function convertDecimalToHex(d) {
        return Math.round(parseFloat(d) * 255).toString(16);
    }
    // Converts a hex value to a decimal
    function convertHexToDecimal(h) {
        return parseIntFromHex(h) / 255;
    }
    var matchers = function() {
        // <http://www.w3.org/TR/css3-values/#integers>
        var CSS_INTEGER = "[-\\+]?\\d+%?";
        // <http://www.w3.org/TR/css3-values/#number-value>
        var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
        // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
        var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
        // Actual matching.
        // Parentheses and commas are optional, but not required.
        // Whitespace can take the place of commas or opening paren
        var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        return {
            CSS_UNIT: new RegExp(CSS_UNIT),
            rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
            rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
            hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
            hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
            hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
            hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
            hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
            hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
        };
    }();
    // `isValidCSSUnit`
    // Take in a single string / number and check to see if it looks like a CSS unit
    // (see `matchers` above for definition).
    function isValidCSSUnit(color) {
        return !!matchers.CSS_UNIT.exec(color);
    }
    // `stringInputToObject`
    // Permissive string parsing.  Take in a number of formats, and output an object
    // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
    function stringInputToObject(color) {
        color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
        var named = false;
        if (names[color]) {
            color = names[color];
            named = true;
        } else if (color == "transparent") return {
            r: 0,
            g: 0,
            b: 0,
            a: 0,
            format: "name"
        };
        // Try to match string input using regular expressions.
        // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
        // Just return an object and let the conversion functions handle that.
        // This way the result will be the same whether the tinycolor is initialized with string or object.
        var match;
        if (match = matchers.rgb.exec(color)) return {
            r: match[1],
            g: match[2],
            b: match[3]
        };
        if (match = matchers.rgba.exec(color)) return {
            r: match[1],
            g: match[2],
            b: match[3],
            a: match[4]
        };
        if (match = matchers.hsl.exec(color)) return {
            h: match[1],
            s: match[2],
            l: match[3]
        };
        if (match = matchers.hsla.exec(color)) return {
            h: match[1],
            s: match[2],
            l: match[3],
            a: match[4]
        };
        if (match = matchers.hsv.exec(color)) return {
            h: match[1],
            s: match[2],
            v: match[3]
        };
        if (match = matchers.hsva.exec(color)) return {
            h: match[1],
            s: match[2],
            v: match[3],
            a: match[4]
        };
        if (match = matchers.hex8.exec(color)) return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
        };
        if (match = matchers.hex6.exec(color)) return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
        };
        if (match = matchers.hex4.exec(color)) return {
            r: parseIntFromHex(match[1] + "" + match[1]),
            g: parseIntFromHex(match[2] + "" + match[2]),
            b: parseIntFromHex(match[3] + "" + match[3]),
            a: convertHexToDecimal(match[4] + "" + match[4]),
            format: named ? "name" : "hex8"
        };
        if (match = matchers.hex3.exec(color)) return {
            r: parseIntFromHex(match[1] + "" + match[1]),
            g: parseIntFromHex(match[2] + "" + match[2]),
            b: parseIntFromHex(match[3] + "" + match[3]),
            format: named ? "name" : "hex"
        };
        return false;
    }
    function validateWCAG2Parms(parms) {
        // return valid WCAG2 parms for isReadable.
        // If input parms are invalid, return {"level":"AA", "size":"small"}
        var level, size;
        parms = parms || {
            level: "AA",
            size: "small"
        };
        level = (parms.level || "AA").toUpperCase();
        size = (parms.size || "small").toLowerCase();
        if (level !== "AA" && level !== "AAA") level = "AA";
        if (size !== "small" && size !== "large") size = "small";
        return {
            level: level,
            size: size
        };
    }
    return tinycolor;
});


/**
 * @typedef SongChangeEventData
 * @property {Song} song
 * @property {SseResponse} sse_response
 */ 
class $daa1007162f1f188$var$SongChangeEvent extends (0, $323a7ebe6d2042d1$export$2e2bcd8739ae039) {
    /** @inheritDoc */ eventName = 'playost.song.change';
    /** @var {Song} song */ song;
    /** @var {SseResponse} sse_response */ sse_response;
    /**
     * @inheritDoc
     * @param {Song} song
     * @param {SseResponse} sse_response
     */ constructor(song, sse_response){
        super();
        this.song = song;
        this.sse_response = sse_response;
    }
    /**
     * Extract the song from the SongChangeEvent
     * @param {SongChangeEventData} evData
     * @return {Song|null}
     */ static getSong(evData) {
        return evData.song || null;
    }
    /**
     * Extract the SSE response from the SongChangeEvent
     * @param {SongChangeEventData} evData
     * @return {SseResponse|null}
     */ static getSseResponse(evData) {
        return evData.sse_response || null;
    }
    /**
     * @inheritDoc
     * @return {SongChangeEventData}
     */ toJson() {
        return {
            song: this.song,
            sse_response: this.sse_response
        };
    }
}
var $daa1007162f1f188$export$2e2bcd8739ae039 = $daa1007162f1f188$var$SongChangeEvent;


class $a061eebc78dab9ce$var$ArtController extends (0, $f654c2c4c7a6b3f4$export$2e2bcd8739ae039) {
    /** @inheritDoc */ constructor(config = {}){
        config = (0, $61621335a50cffc3$export$2e2bcd8739ae039).deepMerge({
            defaultArt: null,
            checkNoArt: true,
            paletteTolerance: 10,
            selectors: {
                artWrapper: '.player__thumb',
                coverThumb: '.cover',
                blurThumb: '.blur'
            }
        }, config);
        super(config);
        this.bindEvents();
    }
    bindEvents() {
        const _self = this;
        (0, $daa1007162f1f188$export$2e2bcd8739ae039).getInstance().bind(/** @param {SongChangeEventData} evData */ (evData)=>{
            this.update((0, $daa1007162f1f188$export$2e2bcd8739ae039).getSong(evData));
        });
    }
    /**
	 * Update the artwork environment
	 * @param {Song} song
	 */ update(song) {
        // Determining if we check the artwork first or not
        if (this.options.checkNoArt) {
            const _self = this;
            (0, $4a05199e3e345b29$export$2e2bcd8739ae039).verify(song.art).then(()=>{
                _self.updateArtwork(song);
            }).catch(()=>{
                song.art = _self.options.defaultArt;
                _self.updateArtwork(song);
            });
        } else this.updateArtwork(song);
    }
    /**
	 * Update the global artwork
	 * @param {Song} song
	 */ updateArtwork(song) {
        const _self = this;
        this.dom.coverThumb.src = song.art;
        this.dom.coverThumb.alt = song.album;
        this.dom.blurThumb.src = song.art;
        this.dom.blurThumb.alt = song.album;
        // Make sure image is finished loading
        if (this.dom.coverThumb.complete) this.setCssDominantColorVar(this.dom.coverThumb);
        else this.dom.coverThumb.addEventListener('load', function() {
            _self.setCssDominantColorVar(_self.dom.coverThumb);
        });
    }
    /**
	 * Calculate and generate the CSS global variable for the art's dominant color
	 * @param {HTMLElement} img
	 */ setCssDominantColorVar(img) {
        const colorThief = new (0, $e76ad0e8457140cb$export$2e2bcd8739ae039)();
        let color = '0, 0, 0';
        let contrast = '255, 255, 255, 1';
        try {
            color = colorThief.getColor(img, 10);
            let aPalette = colorThief.getPalette(img, this.options.paletteTolerance, 10).map((col)=>{
                return `rgb(${col})`;
            });
            contrast = (0, (/*@__PURE__*/$parcel$interopDefault($fa90ed4ba7c7f833$exports))).mostReadable(`rgb(${color})`, aPalette, {
                includeFallbackColors: true
            }).toRgb();
        } catch (e) {
            console.error(e.message);
        }
        const root = document.querySelector(':root');
        root.style.setProperty('--playost--art--dominant-color', `${color}`);
        root.style.setProperty('--playost--art--contrast-color', `${contrast.r}, ${contrast.g}, ${contrast.b}`);
    }
}
var $a061eebc78dab9ce$export$2e2bcd8739ae039 = $a061eebc78dab9ce$var$ArtController;





class $40859f5bd268c5d1$var$SongInfoController extends (0, $f654c2c4c7a6b3f4$export$2e2bcd8739ae039) {
    /** @inheritDoc */ constructor(config = {}){
        config = (0, $61621335a50cffc3$export$2e2bcd8739ae039).deepMerge({
            selectors: {
                songInfoWrapper: '.player__infos',
                title: ".player__infos_title",
                album: ".player__infos_album",
                artist: ".player__infos_artist"
            }
        }, config);
        super(config);
        this.bindEvents();
    }
    /** Bind the controller's watched events */ bindEvents() {
        const _self = this;
        (0, $daa1007162f1f188$export$2e2bcd8739ae039).getInstance().bind(/** @param {SongChangeEventData} evData */ (evData)=>{
            _self.update((0, $daa1007162f1f188$export$2e2bcd8739ae039).getSong(evData));
        });
    }
    /**
     * Update the song's information
     * @param {Song} song
     */ update(song) {
        this.dom.title.textContent = song.title;
        this.dom.album.textContent = song.album;
        this.dom.artist.textContent = song.artist;
    }
}
var $40859f5bd268c5d1$export$2e2bcd8739ae039 = $40859f5bd268c5d1$var$SongInfoController;






class $61a1a2a2e953ce25$var$HistoryController extends (0, $f654c2c4c7a6b3f4$export$2e2bcd8739ae039) {
    /** @var {HTMLElement} domTemplate */ domTemplate;
    /** @inheritDoc */ constructor(config = {}){
        config = (0, $61621335a50cffc3$export$2e2bcd8739ae039).deepMerge({
            defaultArt: null,
            checkNoArt: true,
            selectors: {
                playlistHistoryWrapper: '#playlist',
                nextSongWrapper: '.playlist__next',
                currentSongWrapper: '.playlist__current',
                previousSongListWrapper: '.playlist__previous_list',
                template: '.playlist__song_template'
            }
        }, config);
        super(config);
        this.generateDomTemplate();
        this.bindEvents();
    }
    /** Generate a DOM version of the template */ generateDomTemplate() {
        const parsedDOM = new DOMParser().parseFromString(this.dom.template.innerHTML.trim(), 'text/html');
        this.domTemplate = parsedDOM.body.firstChild.cloneNode(true);
    }
    /** Bind all controller's events */ bindEvents() {
        const _self = this;
        // Updating the history
        (0, $daa1007162f1f188$export$2e2bcd8739ae039).getInstance().bind(/** @param {SongChangeEventData} evData */ (evData)=>{
            const resp = (0, $daa1007162f1f188$export$2e2bcd8739ae039).getSseResponse(evData);
            _self.updateNextSong(resp.nextSong);
            _self.updateCurrentSong(resp.nowPlaying);
            _self.updatePreviousList(resp.history);
        });
    }
    /**
     * Update the "next song" block
     * @param {Song} song
     */ updateNextSong(song) {
        const _self = this;
        this.generateSongDomElement(song).then((domElement)=>{
            _self.dom.nextSongWrapper.replaceChildren(domElement);
        });
    }
    /**
     * Update the "current song" block
     * @param {Song} song
     */ updateCurrentSong(song) {
        const _self = this;
        this.generateSongDomElement(song).then((domElement)=>{
            _self.dom.currentSongWrapper.replaceChildren(domElement);
        });
    }
    /**
     * Update the "previous song list" block
     * @param {Song[]} songs
     */ updatePreviousList(songs) {
        const _self = this;
        const aNewSongs = [];
        new Promise((resolve)=>{
            songs.forEach((s, k)=>{
                _self.generateSongDomElement(s).then((domElement)=>{
                    aNewSongs.push(domElement);
                    if (k === songs.length - 1) resolve(aNewSongs);
                });
            });
        }).then((aNewSongs)=>{
            _self.dom.previousSongListWrapper.replaceChildren(...aNewSongs);
        });
    }
    /**
     * Generate a DOM element for the given song
     * @param {Song} song
     * @return {Promise<HTMLElement>}
     */ generateSongDomElement(song) {
        const _self = this;
        return new Promise((resolve, reject)=>{
            const domSong = _self.domTemplate.cloneNode(true);
            if (_self.options.checkNoArt) (0, $4a05199e3e345b29$export$2e2bcd8739ae039).verify(song.art).then(()=>{
                _self.injectSongData(song, domSong);
                resolve(domSong);
            }).catch(()=>{
                song.art = _self.options.defaultArt;
                _self.injectSongData(song, domSong);
                resolve(domSong);
            });
            else {
                _self.injectSongData(song, domSong);
                resolve(domSong);
            }
        });
    }
    /**
     * Inject the song's data in its DOM Element
     * @param {Song} song
     * @param {HTMLElement} domElement
     */ injectSongData(song, domElement) {
        const domArtwork = domElement.querySelector('[data-field="artwork"]');
        if (domArtwork) {
            domArtwork.src = song.art;
            domArtwork.alt = song.album;
        }
        domElement.querySelector('[data-field="album"]').textContent = song.album;
        domElement.querySelector('[data-field="title"]').textContent = song.title;
        domElement.querySelector('[data-field="artist"]').textContent = song.artist;
    }
}
var $61a1a2a2e953ce25$export$2e2bcd8739ae039 = $61a1a2a2e953ce25$var$HistoryController;



/**
 * @typedef SseChangeEventData
 * @property {SseResponse} sse_response
 */ 
/**
 * Event triggered when the system receive an SSE update
 */ class $99167f67a0a12a05$var$SseChangeEvent extends (0, $323a7ebe6d2042d1$export$2e2bcd8739ae039) {
    /** @inheritDoc */ eventName = 'playost.sse.response';
    /** @var {SseResponse} sse_response */ sse_response;
    /**
     * @inheritDoc
     * @param {SseResponse} resp
     */ constructor(resp){
        super();
        this.sse_response = resp;
    }
    /**
     * Extract the SSE Response from the SseChangeEvent
     * @param {SseChangeEventData} evData
     * @return {SseResponse|null}
     */ static getSseResponse(evData) {
        return evData.sse_response || null;
    }
    /**
     * @inheritDoc
     * @return {SseChangeEventData}
     */ toJson() {
        return {
            sse_response: this.sse_response
        };
    }
}
var $99167f67a0a12a05$export$2e2bcd8739ae039 = $99167f67a0a12a05$var$SseChangeEvent;








class $0f6a12f7f3958aa2$var$PlayerProgressController extends (0, $f654c2c4c7a6b3f4$export$2e2bcd8739ae039) {
    /** @var {number} lastInterval Define the last call of requestAnimationFrame */ lastInterval = 0;
    /** @var {number} interval Define the period between two requestAnimationFrame callback execution */ interval = 1000;
    /** @var {number|null} animationID RequestAnimationFrame ID */ animationID = null;
    /** @inheritDoc */ constructor(config = {}){
        config = (0, $61621335a50cffc3$export$2e2bcd8739ae039).deepMerge({
            time_shift: 0,
            selectors: {
                bar: ".player__progress__bar",
                count: ".player__progress__count",
                total: ".player__progress__total"
            }
        }, config);
        super(config);
        this.bindEvents();
    }
    /** Bind the controller's watched events */ bindEvents() {
        const _self = this;
        (0, $99167f67a0a12a05$export$2e2bcd8739ae039).getInstance().bind(/** @param {SseChangeEventData} evData */ (evData)=>{
            _self.update((0, $99167f67a0a12a05$export$2e2bcd8739ae039).getSseResponse(evData).nowPlaying);
        });
    }
    /**
     * Update the song's progress bar
     * @param {Song} song
     */ update(song) {
        const _self = this;
        const elapsedTime = Math.min(Math.max(0, parseInt(song.elapsed) + parseInt(this.options.time_shift)), song.duration);
        /*console.debug('Chanson / Temps', {
            Nom: song.title,
            Jeu: song.album,
            "Temps brut": song.elapsed,
            "Temps shifted": elapsedTime,
            "Temps Converti": this.formatTime( elapsedTime )
        });*/ this.stop();
        this.animationID = requestAnimationFrame(()=>_self.updateCountTime(elapsedTime, song.duration));
    }
    /**
     * Stop the current animation frame
     */ stop() {
        if (this.animationID) {
            cancelAnimationFrame(this.animationID);
            this.animationID = null;
        }
    }
    /**
     * Format the given seconds to a time string mm:ss
     * @param {number} time
     * @return {string}
     */ formatTime(time) {
        const minutes = Math.floor(time / 60);
        const remainingSeconds = time % 60;
        const formattedSeconds = String(remainingSeconds).padStart(2, '0');
        return `${minutes}:${formattedSeconds}`;
    }
    /**
     * Update the time counter, based on a requestAnimationFrame
     * @param {number} time
     * @param {number} duration
     */ updateCountTime(time, duration) {
        const _self = this;
        if (time >= duration) time = 0;
        if (Date.now() - this.lastInterval >= this.interval) {
            this.lastInterval = Date.now();
            this.dom.total.textContent = this.formatTime(duration);
            this.dom.count.textContent = this.formatTime(time);
            this.dom.bar.value = time / duration * 100;
            time = time + 1;
        }
        this.animationID = requestAnimationFrame(()=>_self.updateCountTime(time, duration));
    }
}
var $0f6a12f7f3958aa2$export$2e2bcd8739ae039 = $0f6a12f7f3958aa2$var$PlayerProgressController;




/**
 * @typedef PlayStateEventData
 * @property {Station} station
 */ 
class $6f01faaef46a50ab$var$PlayStateEvent extends (0, $323a7ebe6d2042d1$export$2e2bcd8739ae039) {
    /** @inheritDoc */ eventName = 'playost.play';
    /** @var {Station} station The currently played station */ station;
    /**
     * @inheritDoc
     * @param {Station} station
     */ constructor(station){
        super();
        this.station = station;
    }
    /**
     * Extract the played station from the PlayStateEvent
     * @param {PlayStateEventData} evData
     * @return {Station|null}
     */ static getStation(evData) {
        return evData.station || null;
    }
    /**
     * @inheritDoc
     * @return {PlayStateEventData}
     */ toJson() {
        return {
            station: this.station
        };
    }
}
var $6f01faaef46a50ab$export$2e2bcd8739ae039 = $6f01faaef46a50ab$var$PlayStateEvent;





class $279800561f565e28$var$StopStateEvent extends (0, $323a7ebe6d2042d1$export$2e2bcd8739ae039) {
    /** @inheritDoc */ eventName = 'playost.stop';
}
var $279800561f565e28$export$2e2bcd8739ae039 = $279800561f565e28$var$StopStateEvent;


class $57ba9bfb6cb25249$var$PlayerControlsController extends (0, $f654c2c4c7a6b3f4$export$2e2bcd8739ae039) {
    /** @var {boolean} playState The current playing state of the player */ playState = false;
    /** @var {Station} station The current selected station */ station;
    /**
     * @inheritDoc
     * @param {Object} config
     * @param {HTMLElement|null} domPlayer
     **/ constructor(config = {}, domPlayer = null){
        config = (0, $61621335a50cffc3$export$2e2bcd8739ae039).deepMerge({
            selectors: {
                playButton: ".controls__statut"
            }
        }, config);
        super(config);
        this.dom.player = domPlayer;
        this.bindEvents();
    }
    /** Bind interaction events to each element */ bindEvents() {
        const _self = this;
        this.dom.playButton.addEventListener('click', (e)=>{
            const playBtn = e.currentTarget;
            const currentState = playBtn.getAttribute('aria-state');
            if ('play' === currentState) this.play();
            else this.stop();
        }, false);
        // Station change events
        (0, $b59c416e021af273$export$2e2bcd8739ae039).getInstance().bind(/** @param {StationsFetchedEventData} evData */ (evData)=>{
            _self.setStation((0, $b59c416e021af273$export$2e2bcd8739ae039).getDefaultStation(evData));
        });
        (0, $5a530bd591a84222$export$2e2bcd8739ae039).getInstance().bind(/** @param {StationChangeEventData} evData */ (evData)=>{
            const oldPlayState = _self.playState;
            _self.stop();
            _self.setStation((0, $5a530bd591a84222$export$2e2bcd8739ae039).getStation(evData));
            if (oldPlayState) _self.play();
        });
    }
    /** Restore the stream play state */ play() {
        const _self = this;
        if (this.station) {
            this.dom.player.src = this.station.listen_url;
            this.dom.player.load();
            // setTimeout, otherwise play event is not raised normally due to the "load()" call
            setTimeout((player)=>{
                player.play().then(()=>{
                    _self.playState = true;
                    _self.dom.playButton.setAttribute('aria-state', 'stop');
                    new (0, $6f01faaef46a50ab$export$2e2bcd8739ae039)(_self.station).dispatch();
                });
            }, 0, this.dom.player);
        }
    }
    /** Stop the stream (not paused) */ stop() {
        this.dom.player.src = '';
        this.dom.player.pause();
        this.playState = false;
        this.dom.playButton.setAttribute('aria-state', 'play');
        new (0, $279800561f565e28$export$2e2bcd8739ae039)().dispatch();
        // setTimeout, otherwise pause event is not raised normally due to the "load()" call
        setTimeout((player)=>{
            player.load(); // This stops the stream from downloading
        }, 0, this.dom.player);
    }
    /**
     * Change the player URL for the given station
     * @param {Station} station
     */ setStation(station) {
        this.station = station;
    }
}
var $57ba9bfb6cb25249$export$2e2bcd8739ae039 = $57ba9bfb6cb25249$var$PlayerControlsController;




/**
 * @typedef VolumeChangeEventData
 * @property {Object} player
 * @property {number} player.volume
 */ 
class $489c16aecfcb08aa$var$VolumeChangeEvent extends (0, $323a7ebe6d2042d1$export$2e2bcd8739ae039) {
    /** @inheritDoc */ eventName = 'playost.player.volume.change';
    /** @var {number} volume */ volume;
    /**
     * @inheritDoc
     * @param {number} volume
     */ constructor(volume){
        super();
        this.volume = volume;
    }
    /**
     * Extract the volume value from the VolumeChangeEvent
     * @param {VolumeChangeEventData} evData
     * @return {number|null}
     */ static getVolume(evData) {
        return evData.player.volume || null;
    }
    /**
     * @inheritDoc
     * @return {VolumeChangeEventData}
     */ toJson() {
        return {
            player: {
                volume: this.volume
            }
        };
    }
}
var $489c16aecfcb08aa$export$2e2bcd8739ae039 = $489c16aecfcb08aa$var$VolumeChangeEvent;


/**
 * @typedef MuteStateChangeEventData
 * @property {Object} player
 * @property {boolean} player.muted
 */ 
class $97212c299504af43$var$MuteStateChangeEvent extends (0, $323a7ebe6d2042d1$export$2e2bcd8739ae039) {
    /** @inheritDoc */ eventName = 'playost.player.mute.change';
    /** @var {boolean} state */ state;
    /**
     * @inheritDoc
     * @param {boolean} state
     */ constructor(state){
        super();
        this.state = state;
    }
    /**
     * Extract the muted state from the MuteStateChangeEvent
     * @param {MuteStateChangeEventData} evData
     * @return {boolean|null}
     */ static getMutedState(evData) {
        return evData.player.muted;
    }
    /**
     * @inheritDoc
     * @return {MuteStateChangeEventData}
     */ toJson() {
        return {
            player: {
                muted: this.state
            }
        };
    }
}
var $97212c299504af43$export$2e2bcd8739ae039 = $97212c299504af43$var$MuteStateChangeEvent;


class $c35efe8d62ee6514$var$PlayerVolumeController extends (0, $f654c2c4c7a6b3f4$export$2e2bcd8739ae039) {
    /** @var {string} #localStorageVolumeProperty */ #localStorageVolumeProperty = 'playost_volume';
    /** @var {HTMLAudioElement} dom.player */ /**
     * @inheritDoc
     * @param {Object} config
     * @param {HTMLElement|null} domPlayer
     **/ constructor(config = {}, domPlayer = null){
        config = (0, $61621335a50cffc3$export$2e2bcd8739ae039).deepMerge({
            selectors: {
                volumeRange: ".form-range",
                volumeButton: ".controls__volume__button"
            }
        }, config);
        super(config);
        this.dom.player = domPlayer;
        this.bindEvents();
        // Initializing the volume with stored value
        const storedVolume = this.getStoredVolume();
        this.dom.volumeRange.value = storedVolume;
        this.dom.player.volume = storedVolume / 100;
    }
    /**
     * Store the given volume value in local storage
     * @param {Number|string} value
     */ storeVolume(value) {
        localStorage.setItem(this.#localStorageVolumeProperty, '' + value);
    }
    /**
     * Fetch the stored volume value
     * @return {Number}
     */ getStoredVolume() {
        return parseInt(localStorage.getItem(this.#localStorageVolumeProperty) ?? 10);
    }
    /**
     * Bind all elements events
     */ bindEvents() {
        const _self = this;
        /** Volume change with the range input */ this.dom.volumeRange.addEventListener('change', (e)=>{
            _self.syncVolume(e.currentTarget.value);
        }, false);
        /** Mute toggle */ this.dom.volumeButton.addEventListener('click', (e)=>{
            const state = e.currentTarget.getAttribute('aria-state');
            if ('muted' === state) _self.calculateVolumeButtonStatus();
            else _self.calculateVolumeButtonStatus(0);
            new (0, $97212c299504af43$export$2e2bcd8739ae039)('muted' !== state).dispatch();
        });
        /** Global change when the volume is changed by the range */ (0, $489c16aecfcb08aa$export$2e2bcd8739ae039).getInstance().bind(/** @param {VolumeChangeEventData} evData */ (evData)=>{
            const vol = (0, $489c16aecfcb08aa$export$2e2bcd8739ae039).getVolume(evData);
            _self.calculateVolumeButtonStatus(vol);
            _self.storeVolume(vol);
            _self.dom.player.muted = false;
        });
        (0, $97212c299504af43$export$2e2bcd8739ae039).getInstance().bind(/** @param {MuteStateChangeEventData} evData */ (evData)=>{
            _self.dom.player.muted = (0, $97212c299504af43$export$2e2bcd8739ae039).getMutedState(evData);
        });
    }
    /**
     * Calculate the status of the volume button
     * @param {number|null} volume
     */ calculateVolumeButtonStatus(volume = null) {
        if (null === volume) volume = this.dom.volumeRange.value;
        let state = null;
        if (volume === 0) state = 'muted';
        else if (volume < 50) state = 'weak';
        else state = 'strong';
        this.dom.volumeButton.setAttribute('aria-state', state);
    }
    /**
     * Sync the volume between every elements: range, button and player
     * @param {number|string} forcedValue
     */ syncVolume(forcedValue = null) {
        forcedValue = parseFloat(forcedValue);
        // Else syncing the other way around
        this.dom.player.volume = forcedValue / 100;
        new (0, $489c16aecfcb08aa$export$2e2bcd8739ae039)(forcedValue).dispatch();
    }
}
var $c35efe8d62ee6514$export$2e2bcd8739ae039 = $c35efe8d62ee6514$var$PlayerVolumeController;



class $acdd741f4ca12665$var$PlayerController extends (0, $f654c2c4c7a6b3f4$export$2e2bcd8739ae039) {
    /** @var {HTMLElement} DomPlayerElement */ static DomPlayerElement;
    /** @var {PlayerProgressController} playerProgressController */ playerProgressController;
    /** @var {PlayerControlsController} playerControlsController */ playerControlsController;
    /** @var {PlayerVolumeController} playerVolumeController */ playerVolumeController;
    /**
     * Self constructor
     * @param {Object} config
     */ constructor(config = {}){
        config = (0, $61621335a50cffc3$export$2e2bcd8739ae039).deepMerge({
            selectors: {
                player: '.player__audio'
            },
            playerControls: {
                selectors: {}
            },
            playerVolume: {
                selectors: {}
            },
            playerProgress: {}
        }, config);
        super(config);
        // Fetch the player DOM Element
        $acdd741f4ca12665$var$PlayerController.DomPlayerElement = document.querySelector(this.options.selectors.player);
        // Instantiating sub-controllers
        this.playerProgressController = new (0, $0f6a12f7f3958aa2$export$2e2bcd8739ae039)(this.options.playerProgress);
        this.playerControlsController = new (0, $57ba9bfb6cb25249$export$2e2bcd8739ae039)(this.options.playerControls, $acdd741f4ca12665$var$PlayerController.DomPlayerElement);
        this.playerVolumeController = new (0, $c35efe8d62ee6514$export$2e2bcd8739ae039)(this.options.playerVolume, $acdd741f4ca12665$var$PlayerController.DomPlayerElement);
    }
}
var $acdd741f4ca12665$export$2e2bcd8739ae039 = $acdd741f4ca12665$var$PlayerController;




class $168c517d94a19652$var$PopinController extends (0, $f654c2c4c7a6b3f4$export$2e2bcd8739ae039) {
    /**
     * @inheritDoc
     * @param {Object} config
     */ constructor(config = {}){
        config = (0, $61621335a50cffc3$export$2e2bcd8739ae039).deepMerge({
            closeButtonSelector: '.popin--action-close',
            containerSelector: '.popin__container',
            openerSelector: '.popin--action-open',
            popinWrapperSelector: '.popin'
        }, config);
        super(config);
        this.bindEvents();
    }
    /** Bind the controllers associated events */ bindEvents() {
        const _self = this;
        /** Delegation event binding */ document.addEventListener('click', (e)=>{
            // Opening the popin
            if (e.target.matches(_self.options.openerSelector) || e.target.closest(_self.options.openerSelector)) {
                _self.togglePopin(e.target.closest(_self.options.popinWrapperSelector), true);
                return;
            }
            // Closing button
            if (e.target.matches(_self.options.closeButtonSelector) || e.target.closest(_self.options.closeButtonSelector)) {
                _self.togglePopin(e.target.closest(_self.options.popinWrapperSelector), false);
                return;
            }
            // Prevent auto-closing
            const domContainer = e.target.closest(_self.options.containerSelector);
            if (domContainer) return;
            // Global closing
            const domPopin = e.target.closest(_self.options.popinWrapperSelector);
            if (domPopin) _self.togglePopin(domPopin, false);
        }, true);
    }
    /**
     * Toggle the state of the popin
     * @param {HTMLElement} popin
     * @param {boolean} state
     */ togglePopin(popin, state) {
        popin.querySelector(this.options.containerSelector).setAttribute('aria-hidden', !state ? 'true' : 'false');
        popin.querySelector(this.options.openerSelector).setAttribute('aria-expanded', state ? 'true' : 'false');
        popin.classList.toggle('open', state);
    }
}
var $168c517d94a19652$export$2e2bcd8739ae039 = $168c517d94a19652$var$PopinController;







class $5e5a56af841f6229$var$AnimationController extends (0, $f654c2c4c7a6b3f4$export$2e2bcd8739ae039) {
    /** @var {{animation: number|null, position: number, direction: number, moving: boolean, target: HTMLElement|Element}[], timeout: any} animations */ animations = [];
    constructor(config){
        config = (0, $61621335a50cffc3$export$2e2bcd8739ae039).deepMerge({
            animateSelector: '.scroll',
            directionChangeDelay: 2000,
            speed: 1
        }, config);
        super(config);
        this.bindEvents();
    }
    /** Bind this controller's associated events */ bindEvents() {
        const _self = this;
        const resetFunc = ()=>{
            _self.clear().then(()=>{
                // Need setTimeout to shift the flux of execution
                setTimeout(()=>{
                    _self.animateScrollElements();
                });
            });
        };
        (0, $daa1007162f1f188$export$2e2bcd8739ae039).getInstance().bind(resetFunc);
        (0, $5a530bd591a84222$export$2e2bcd8739ae039).getInstance().bind(resetFunc);
    }
    /** Clear all the current animations */ async clear() {
        for(let k in this.animations){
            const anim = this.animations[k];
            if ('object' === typeof anim) {
                anim.target.style.transform = null;
                cancelAnimationFrame(anim.animation);
                clearTimeout(anim.timeout);
            }
        }
        this.animations = [];
    }
    /** Bind an animation on scrollable elements */ animateScrollElements() {
        const _self = this;
        document.querySelectorAll('.scroll').forEach((el, k)=>{
            const textElement = el.querySelector('*');
            const containerWidth = el.offsetWidth;
            const textWidth = textElement.offsetWidth;
            if (textWidth > containerWidth) {
                _self.animations[k] = {
                    animation: null,
                    position: 0,
                    direction: -1,
                    moving: false,
                    target: textElement,
                    timeout: null
                };
                _self.animations[k].timeout = setTimeout((textElement, k)=>{
                    _self.animations[k].moving = true;
                    _self.animations[k].animation = requestAnimationFrame(()=>_self.animate(textElement, k));
                }, _self.options.directionChangeDelay, textElement, k);
            }
        });
    }
    /**
     * Animate the given element
     * @param {HTMLElement} el
     * @param {number} k
     */ animate(el, k) {
        const _self = this;
        if (!this.animations[k].moving) return;
        this.animations[k].position += this.options.speed * this.animations[k].direction;
        if (this.animations[k].position <= -(el.offsetWidth - el.parentElement.offsetWidth) || this.animations[k].position >= 0) {
            this.animations[k].moving = false;
            _self.animations[k].timeout = setTimeout((el, k)=>{
                _self.animations[k].direction *= -1; // Changer de direction
                _self.animations[k].moving = true;
                _self.animations[k].animation = requestAnimationFrame(()=>_self.animate(el, k));
            }, 2000, el, k); // Délai de 2 secondes avant de changer de direction
        }
        el.style.transform = `translateX(${this.animations[k].position}px)`;
        this.animations[k].animation = requestAnimationFrame(()=>this.animate(el, k));
    }
}
var $5e5a56af841f6229$export$2e2bcd8739ae039 = $5e5a56af841f6229$var$AnimationController;




class $621650c5dfdf3476$var$MediaSessionController extends (0, $f654c2c4c7a6b3f4$export$2e2bcd8739ae039) {
    /** @inheritDoc */ constructor(config = {}){
        super(config);
        this.bindEvents();
    }
    /** Bind the controller's watched events */ bindEvents() {
        const _self = this;
        if ('mediaSession' in navigator) (0, $daa1007162f1f188$export$2e2bcd8739ae039).getInstance().bind(/** @param {SongChangeEventData} evData */ (evData)=>{
            _self.update((0, $daa1007162f1f188$export$2e2bcd8739ae039).getSong(evData));
        });
    }
    /**
     * Update the song's information
     * @param {Song} song
     */ update(song) {
        navigator.mediaSession.metadata = new MediaMetadata({
            title: `${song.album} | ${song.title}`,
            artist: song.artist,
            artwork: [
                {
                    src: song.art
                }
            ]
        });
        navigator.mediaSession.setPositionState({
            duration: Infinity
        });
    }
}
var $621650c5dfdf3476$export$2e2bcd8739ae039 = $621650c5dfdf3476$var$MediaSessionController;


class $cd71e5386dc88545$var$PlayOstEngine {
    /** Define engine's default options */ defaultOptions = {
        /** @var {string|null} target Main wrapper selector */ target: null,
        /** @var {AbstractConnector|Class|null} target SSE connector class */ connector: null,
        radio: {
            /** @var {string|null} sse_api Base URI of the radio */ sse_api: null,
            /** @var {Station[]} stations List of the stations */ stations: []
        },
        /** Sub-Controllers potential configs to pass on */ art: {},
        player: {},
        history: {},
        songInfo: {},
        radioStationList: {},
        popin: {},
        animations: {}
    };
    /** Engine compiled options */ options = {};
    /**
	 * @type {Object.<string, HTMLElement>}
	 * @property {HTMLAudioElement} player
	 **/ dom = {};
    /** @var {AbstractConnector} stationConnector SSE Connector's instance */ stationConnector;
    /** @var {RadioStationListController} stationsDomController */ stationsDomController;
    /** @var {ArtController} artDomController */ artDomController;
    /** @var {SongInfoController} songInfoController */ songInfoController;
    /** @var {MediaSessionController} mediaSessionController */ mediaSessionController;
    /** @var {PlayerController} playerController */ playerController;
    /** @var {HistoryController} songHistoryController */ songHistoryController;
    /** @var {PopinController} popinController */ popinController;
    /** @var {AnimationController} animationsController */ animationsController;
    /** @var {Song|null} currentSong The currently played song */ currentSong = null;
    /**
	 * Self constructor
	 * @param {Object<defaultOptions>} options
	 */ constructor(options){
        this.options = (0, $61621335a50cffc3$export$2e2bcd8739ae039).deepMerge(this.defaultOptions, options);
    }
    /** Start the engine */ start() {
        const _self = this;
        /** Instantiating each HTMLElement */ this.dom.wrapper = document.querySelector(this.options.target);
        for(let t in this.options.selectors)this.dom[t] = this.dom.wrapper.querySelector(this.options.selectors[t]);
        // Initializing the radio connector
        this.stationConnector = new this.options.connector(this.options.radio.sse_api);
        /** Generating the standalone sub controllers */ this.popinController = new (0, $168c517d94a19652$export$2e2bcd8739ae039)(this.options.popin);
        this.animationsController = new (0, $5e5a56af841f6229$export$2e2bcd8739ae039)(this.options.animations);
        // Fetching stations
        this.stationConnector.getStationsList().then((stations)=>{
            _self.options.radio.stations = stations;
            // Global PlayOST events
            _self.bindGlobalEvents();
            /** Generating the station-dependant sub controllers */ // Song controllers
            _self.artDomController = new (0, $a061eebc78dab9ce$export$2e2bcd8739ae039)(_self.options.art);
            _self.songInfoController = new (0, $40859f5bd268c5d1$export$2e2bcd8739ae039)(_self.options.songInfo);
            _self.mediaSessionController = new (0, $621650c5dfdf3476$export$2e2bcd8739ae039)(_self.options.songInfo);
            // Player controller
            _self.playerController = new (0, $acdd741f4ca12665$export$2e2bcd8739ae039)(_self.options.player);
            // Song history controller
            _self.songHistoryController = new (0, $61a1a2a2e953ce25$export$2e2bcd8739ae039)(_self.options.history);
            // Stations button list - Note: instantiated last as it triggers an initialization event
            _self.stationsDomController = new (0, $fcfb5ebe1c2d73a6$export$2e2bcd8739ae039)(_self.options.radioStationList, _self.options.radio.stations);
            _self.stationsDomController.generate();
        });
    }
    /**
	 * Bind all global PlayOST events
	 */ bindGlobalEvents() {
        const _self = this;
        /** Immediately starting the handle SSE updates after station initialization */ (0, $b59c416e021af273$export$2e2bcd8739ae039).getInstance().bind(/** @param {StationsFetchedEventData} evData */ (evData)=>{
            _self.changeStationConnector((0, $b59c416e021af273$export$2e2bcd8739ae039).getDefaultStation(evData));
        });
        /** Changing station connector on station change */ (0, $5a530bd591a84222$export$2e2bcd8739ae039).getInstance().bind(/** @param {StationChangeEventData} evData */ (evData)=>{
            _self.changeStationConnector((0, $5a530bd591a84222$export$2e2bcd8739ae039).getStation(evData));
        });
        /** Updating interface on SSE response update */ (0, $99167f67a0a12a05$export$2e2bcd8739ae039).getInstance().bind(/** @param {SseChangeEventData} evData */ (evData)=>{
            _self.sseEventCallback((0, $99167f67a0a12a05$export$2e2bcd8739ae039).getSseResponse(evData));
        });
    }
    /**
	 * Trigger a station change
	 * @param {Station} station
	 */ changeStationConnector(station) {
        const _self = this;
        if (undefined === station) throw new Error("No station to play");
        // If a connector is already watching, stopping it
        if (this.stationConnector) this.stationConnector.stop();
        // Watching the given station flux
        this.stationConnector.watch(station);
    }
    /**
	 * Handle response from SSE event
	 * @param {SseResponse} resp
	 */ sseEventCallback(resp) {
        if (null === this.currentSong || this.currentSong.id !== resp.nowPlaying.id) {
            this.currentSong = resp.nowPlaying;
            new (0, $daa1007162f1f188$export$2e2bcd8739ae039)(this.currentSong, resp).dispatch();
        }
    }
}
var $cd71e5386dc88545$export$2e2bcd8739ae039 = $cd71e5386dc88545$var$PlayOstEngine;



class $09a4823c6d9dbb4d$var$AbstractConnector {
    /** @var {string} uri SSE URI of the AzuraCast server */ uri;
    /** @var {Station|null} station The station's slug */ station;
    /** @var {EventSource} eventSource The EventSource instance for the SSE connection */ eventSource;
    /**
	 * Self constructor
	 * @param {string} uri
	 */ constructor(uri){
        if (new.target === $09a4823c6d9dbb4d$var$AbstractConnector) throw new Error("AbstractConnector is abstract and cannot be instantiated");
        this.uri = uri;
        if ('' === this.uri || 'string' !== typeof this.uri) throw new Error('Wrong AzuraCast base URI');
    }
    /**
	 * Fetch list of stations from the radio
	 * @return {Promise<Station[]>}
	 */ getStationsList() {
        throw new Error('Class must implement the "getStationsList" method');
    }
    /**
	 * Watch the radio station
	 * @param {Station} station
	 */ watch(station) {
        this.station = station;
        const _self = this;
        const watchParams = this.getWatchParams();
        this.eventSource = new EventSource(this.uri + (watchParams ? '?' + watchParams.toString() : ''));
        this.eventSource.onmessage = (e)=>{
            if (e.data === '{}') return;
            const jsonData = JSON.parse(e.data);
            const handledData = _self.handleData(jsonData);
            new (0, $99167f67a0a12a05$export$2e2bcd8739ae039)(handledData).dispatch();
        };
    }
    /**
	 * Stop the SSE watching of the station
	 */ stop() {
        this.eventSource && this.eventSource.close();
        this.eventSource = undefined;
    }
    /**
	 * Generate the parameters for the SSE connection
	 * @return {URLSearchParams|null}
	 */ getWatchParams() {
        throw new Error('Class must implement the "getWatchParams" method');
    }
    /**
	 * Format the received data in to a SseResponse entity
	 * @param {Object} data
	 * @return {SseResponse}
	 */ handleData(data) {
        throw new Error('Class must implement the "handleData" method');
    }
}
var $09a4823c6d9dbb4d$export$2e2bcd8739ae039 = $09a4823c6d9dbb4d$var$AbstractConnector;


class $d9fdf61da1ae5d69$var$SseResponse {
    /** @var {Station} station */ station;
    /** @var {Song} nowPlaying */ nowPlaying;
    /** @var {Song} nextSong */ nextSong;
    /** @var {Song[]} history */ history = [];
}
var $d9fdf61da1ae5d69$export$2e2bcd8739ae039 = $d9fdf61da1ae5d69$var$SseResponse;


class $7ffbb2857bc1a921$var$Song {
    /** @var {number} played_at The timestamp when the song starts playing */ played_at;
    /** @var {number} duration The song duration (in seconds) */ duration;
    /** @var {number|null} elapsed The song elapsed time (in seconds) */ elapsed = null;
    /** @var {string} playlist The associated playlist */ playlist;
    /** @var {boolean} is_request Define if the song was requested */ is_request;
    /** @var {string} id The song's id */ id;
    /** @var {string} art The song's artwork / jacket */ art;
    /** @var {Array} custom_fields Potential song's custom fields */ custom_fields = [];
    /** @var {string} title Song's title */ title;
    /** @var {string} artist Song's artist name */ artist;
    /** @var {string} album Song's album name */ album;
    /** @var {string} genre Song's genre */ genre;
    /** @var {string} lyrics Song's lyrics */ lyrics;
}
var $7ffbb2857bc1a921$export$2e2bcd8739ae039 = $7ffbb2857bc1a921$var$Song;


class $fa1748b450082540$var$Station {
    /** @var {number|string} id */ id;
    /** @var {boolean} is_public */ is_public;
    /** @var {string} listen_url */ listen_url;
    /** @var {number|null} bitrate */ bitrate = null;
    /** @var {string} name */ name;
    /** @var {string} shortcode */ shortcode;
    /** @var {string} timezone */ timezone;
}
var $fa1748b450082540$export$2e2bcd8739ae039 = $fa1748b450082540$var$Station;


class $b42fe910138ae685$var$AzuraCastConnector extends (0, $09a4823c6d9dbb4d$export$2e2bcd8739ae039) {
    /** @inheritDoc */ // @TODO Hard coded URI without any link to the URI set in the constructor, need to rework this
    getStationsList() {
        const _self = this;
        return new Promise((resolve, reject)=>{
            fetch('https://radio.playost.com/api/stations').then((resp)=>resp.json()).then((data)=>{
                const aStations = [];
                data.forEach((station)=>{
                    aStations.push(_self.formatStation(station));
                });
                resolve(aStations);
            }).catch((e)=>reject(e));
        });
    }
    /** @inheritDoc */ getWatchParams() {
        const args = {
            "subs": {}
        };
        args.subs[`station:${this.station.shortcode}`] = {
            "recover": true
        };
        return new URLSearchParams({
            "cf_connect": JSON.stringify(args)
        });
    }
    /** @inheritDoc */ handleData(data) {
        if ('connect' in data) {
            // Initial data is sent in the "connect" response as an array of rows similar to individual messages.
            if (Array.isArray(data.connect.subs['station:' + this.station.shortcode].publications) && data.connect.subs['station:' + this.station.shortcode].publications.length > 0) return this.formatSseResponse(data.connect.subs['station:' + this.station.shortcode].publications[0].data.np);
        } else if ('channel' in data) return this.formatSseResponse(data.pub.data.np);
        return null;
    }
    /**
	 * Convert AzuraCast SSE data into generic SseResponse
	 * @param {Object} data
	 * @return {SseResponse}
	 */ formatSseResponse(data) {
        const _self = this;
        const oNowPlaying = new (0, $d9fdf61da1ae5d69$export$2e2bcd8739ae039)();
        oNowPlaying.station = this.station;
        if ('undefined' !== typeof data.now_playing) oNowPlaying.nowPlaying = this.formatSong(data.now_playing);
        if ('undefined' !== typeof data.playing_next) oNowPlaying.nextSong = this.formatSong(data.playing_next);
        if ('undefined' !== typeof data.song_history && Array.isArray(data.song_history)) oNowPlaying.history = data.song_history.map((s)=>{
            return _self.formatSong(s);
        });
        return oNowPlaying;
    }
    /**
	 * Format a received station json data from AzuraCast into a Station object
	 * @param {Object} jsonStationData
	 * @return {Station}
	 */ formatStation(jsonStationData) {
        const oStation = new (0, $fa1748b450082540$export$2e2bcd8739ae039)();
        oStation.id = jsonStationData.id;
        oStation.is_public = jsonStationData.is_public;
        oStation.listen_url = jsonStationData.listen_url;
        oStation.bitrate = jsonStationData.mounts[0].bitrate || null;
        oStation.name = jsonStationData.name;
        oStation.shortcode = jsonStationData.shortcode;
        oStation.timezone = jsonStationData.timezone;
        return oStation;
    }
    /**
	 * Format a received song json data from AzuraCast into a Song object
	 * @param {Object} jsonSongData
	 * @return {Song}
	 */ formatSong(jsonSongData) {
        const oSong = new (0, $7ffbb2857bc1a921$export$2e2bcd8739ae039)();
        oSong.played_at = jsonSongData.played_at;
        oSong.duration = jsonSongData.duration;
        oSong.elapsed = jsonSongData.elapsed || null;
        oSong.playlist = jsonSongData.playlist;
        oSong.is_request = jsonSongData.is_request;
        oSong.id = jsonSongData.song.id;
        oSong.art = jsonSongData.song.art;
        oSong.custom_fields = jsonSongData.song.custom_fields;
        oSong.title = jsonSongData.song.title;
        oSong.artist = jsonSongData.song.artist;
        oSong.album = jsonSongData.song.album;
        oSong.genre = jsonSongData.song.genre;
        oSong.lyrics = jsonSongData.song.lyrics;
        return oSong;
    }
}
var $b42fe910138ae685$export$2e2bcd8739ae039 = $b42fe910138ae685$var$AzuraCastConnector;


new (0, $cd71e5386dc88545$export$2e2bcd8739ae039)({
    target: '#player',
    connector: (0, $b42fe910138ae685$export$2e2bcd8739ae039),
    radio: {
        sse_api: "https://radio.playost.com/api/live/nowplaying/sse"
    },
    art: {
        defaultArt: '/assets/imgs/no-cover.jpg',
        checkNoArt: false
    },
    history: {
        defaultArt: '/assets/imgs/no-cover.jpg',
        checkNoArt: false
    },
    player: {
        playerProgress: {
            time_shift: -4.5
        }
    }
}).start();

})();
//# sourceMappingURL=app.js.map
